import React, { createContext, useContext, useState } from 'react';

type Snackbar = {
  /** メッセージ。 */
  message: string;
  /** ステート。 */
  state?: 'success' | 'error';
};

type SnackbarContextType = {
  /** スナックバーを表示する関数。 */
  snackbar: ({ message, state }: Snackbar) => void;
};

const SnackbarContext = createContext<SnackbarContextType | undefined>(
  undefined
);

export const SnackbarProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarState, setSnackbarState] =
    useState<Snackbar['state']>('success');
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<'open' | 'close'>(
    'close'
  );

  const snackbar = ({ message, state = 'success' }: Snackbar) => {
    setSnackbarMessage(message);
    setSnackbarState(state);
    setIsSnackbarOpen('open');
    setTimeout(() => {
      setIsSnackbarOpen('close');
    }, 2000);
  };

  return (
    <SnackbarContext.Provider value={{ snackbar }}>
      {children}
      <div
        className={`fixed left-1/2 bottom-20 transform -translate-x-1/2 p-4 text-surface noto-sans-jp-medium rounded shadow-lg transition-transform transition-opacity duration-500 
        ${snackbarState === 'success' ? 'bg-primary' : 'bg-error'}
        ${
          isSnackbarOpen === 'open'
            ? 'translate-y-0 opacity-100'
            : 'translate-y-full opacity-0'
        }`}
        style={{ transition: 'transform 0.5s ease, opacity 0.5s ease' }}
      >
        <span>{snackbarMessage}</span>
      </div>
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  const context = useContext(SnackbarContext);
  if (!context) {
    throw new Error('useSnackbar must be used within a SnackbarProvider');
  }
  return context;
};
